module.exports = __webpack_public_path__ + "img/imagenTresVentas.602ddf89.jpg";